<template>
    <div>
        <div class="row">
            <div class="col-md-12 ">
                <el-dialog
                        title="Confirm Cancel"
                        :visible.sync="showConfirmCancel">

                    <p>Are you sure you want to cancel this processing?</p>
                    <el-button v-on:click="cancel()" type="danger">Yes, really cancel.</el-button>
                    <el-button v-on:click="hideConfirmCancel()" type="success">Oops. Actually, keep processing.</el-button>

                </el-dialog>
                <div class="panel panel-default">
                    <div class="panel-heading">{{ chain_display_name }}: <span style="color:gray;">{{extent_name}}</span></div>

                    <div class="panel-body">
                        <el-row>
                            <el-col style="text-align:center;" v-bind:span="column_width" v-for="step in steps">
                                <el-progress type="circle" :percentage="step.percentage"></el-progress>
                                <div>{{ step.current_count_done | commas}} / {{ step.current_count_total | commas}}</div>
                                <div style="text-align:center;"><strong>{{ step.name }}</strong> </div>
                                <div>{{step.elapsed}}</div>
                            </el-col>
                        </el-row>
                        <el-row>
                          <h4>Status: {{status_text}}</h4>
                          <div v-if="llm_usage_display" style="margin-top: 10px;">
                            <strong>{{llm_usage_display}}</strong>
                          </div>
                          <div v-if="status_text=='Queued' && show_waiting_message" style="margin-bottom:20px;">
                              <el-alert
                                      title="You will need to wait before this starts"
                                      type="warning"
                                      effect="dark">
                                  {{ waiting_text }}
                              </el-alert>
                          </div>

                          <el-button v-if="aborted_crawl && !auto_advance" type="primary" @click="unprotected_process()">Process assets from incomplete crawl</el-button>
                          <el-button v-if="chain_done==false" type="primary" @click="confirmCancel()">Cancel</el-button>
                          <el-button v-if="aborted_crawl && show_bleeding_edge==true" @click="restart()">Restart</el-button>
                          <el-popover
                              v-if="crawl_definition && show_bleeding_edge"
                              placement="top-start"
                              title="Crawl Definition"
                              width="500"
                              trigger="hover"
                          >
                            <p v-for="para in crawl_definition">{{para}}</p>
                            <i class="el-icon-info" slot="reference"></i>
                          </el-popover>
                          <span v-if="chain_done==false">
                            <img v-show="heartbeat_index===0" src="/images/progress-1.gif" />
                            <img v-show="heartbeat_index===1" src="/images/progress-2.gif" />
                            <img v-show="heartbeat_index===2" src="/images/progress-3.gif" />
                            <img v-show="heartbeat_index===3" src="/images/progress-4.gif" />
                            <img v-show="heartbeat_index===4" src="/images/progress-5.gif" />
                            <img v-show="heartbeat_index===5" src="/images/progress-4.gif" />
                            <img v-show="heartbeat_index===6" src="/images/progress-3.gif" />
                            <img v-show="heartbeat_index===7" src="/images/progress-2.gif" />
                          </span>
                          <AfterDataImport v-if="chain_type=='import'" v-bind:job_chain_id="job_chain_id" v-bind:extent_id="extent_id" v-bind:chain_done="chain_done" />
                          <AfterAssignment v-if="chain_type=='assign'" v-bind:job_chain_id="job_chain_id" v-bind:extent_id="extent_id" v-bind:chain_done="chain_done" />
                        </el-row>
                    </div>
                </div>
              <div v-if="crawl_step_id" class="panel panel-default">
                <gallery :endPoint="gallery_endpoint" :extent_id="extent_id" ></gallery>
              </div>
              <div v-if="crawl_step_id" class="panel panel-default">
                    <div class="panel-heading">
                        Crawl Progress
                        <span v-if="show_bleeding_edge"><el-button @click="toggle_distribution()">{{toggle_text}}</el-button></span>
                        <el-button @click="toggle_lock_series">{{lock_series_text}}</el-button>
                        <!-- <el-button @click="full_screen()">Full screen chart</el-button> -->
                        <span style="margin-left:10px;"><a :href="error_report_link">Error Report</a></span>
                        <span v-if="chain_done==true" style="margin-left:10px;"><a :href="'/encountered_domains/' + extent_id +  '?job_chain_id=' + job_chain_id " target="_blank">Encountered Domains Report</a></span>
                    </div>
                    <div class="panel-body" id="primary-chart">
                                <CrawlTimeSeries
                                        :height="chart_height"
                                        :width="chart_width"
                                        :distribution="distribution"
                                        :processedData="timeSeriesData"
                                />
                      <div v-if="show_bleeding_edge && this.raw_to_date && this.raw_to_date.hasOwnProperty('retries')" class="markdown" width="100%" style="font-size:smaller">
                        Redirects : {{latest_values.redirects}} ·
                        Retries: {{latest_values.retries}} ·
                        Final Errors: {{latest_values.failures}} ·
                        Crawled: {{latest_values.successes}} ·
                        Will Retry: {{latest_values.will_retry}} ·
                        Found organically: {{latest_values.remaining}} ·
                        Found in sitemap: {{latest_values.sitemap}} ·

                      </div>
                            <div v-if="active_url_list!==[]">
                                <transition-group name="active-list" tag="ul">
                                    <li v-for="(color, url) in active_url_list" v-bind:key="url" style="padding:10px;">
                                            <span v-bind:style="{backgroundColor: color}" style="color:white; padding:10px;">
                                                <a :href="url" target="_blank">{{url}}</a>
                                            </span>
                                    </li>
                                </transition-group>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Also see app.scss!!! That's where some of the transition stuff is stored
    import AfterDataImport from './AfterDataImport.vue'
    import CrawlTimeSeries from "../DataExploration/CrawlTimeSeries";
    import * as screenfull from 'screenfull';
    let done_sound;
    let warning_sound;
    let error_sound;
    export default {
        filters: {
            commas: function(value) {
                if (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                } else {
                    return value
                }
            }
        },
        components: {CrawlTimeSeries},
        props: ['job_chain_id','auto_advance'],
        mounted() {
            // console.log('Component mounted now.')
          document.addEventListener('visibilitychange', this.visibilityChange, false);

          this.listen()
            window.axios.get('/api/jobChains/' + this.job_chain_id)
                .then(response => {
                    var column_count = 0
                  if (response.data.final_status && response.data.final_status.text && response.data.final_status.category!=='unknown') {
                      console.log('setting final_text when got chain info')
                      let error_suffix = response.data.final_error_text ? ': ' + response.data.final_error_text : ''
                      this.status_text = this.final_text = response.data.final_status.text + error_suffix
                    } else {
                    console.log('did NOT set final_text when got chain info')
                  }
                    response.data.job_chain_steps.forEach((step) => {
                        var temp_step = {
                            percentage:0,
                            name: ""
                        }
                        temp_step.name = step.job_chain_type_step.display_name
                        // console.log('mammals')
                        // console.log(step)
                        if (temp_step.name === "Crawl") this.crawl_step_id = step.id
                        // console.log(this.crawl_step_id)
                        temp_step.percentage = 0
                        temp_step.highest_time_received = 0
                        temp_step.elapsed = ''
                        this.$set(this.steps, step.id, temp_step)
                        // console.log(step.job_chain_id)
                        // console.log("abcdef")
                        // console.log(temp_step)
                        column_count++
                    })
                    this.column_width = Math.floor(24/column_count) // once get 5 or more circles, no longer have whole number when dividing 24
                    // console.log(this.steps)
                    this.chain_display_name = response.data.job_chain_type.display_name
                    this.chain_type = response.data.job_chain_type.name
                    this.extent_id = response.data.extent_id
                    this.extent_name = response.data.extent.name
                    // console.log(this.job_chain_display_name)
                    window.axios.post('/api/jobChains/trigger/' + this.job_chain_id)
                        .then(response => {
                            // console.log(response)
                            this.change_status("Queued")
                            // console.log("about to get initial timeseries data")
                            if(this.crawl_step_id) {
                                this.getInitialTimeSeriesData()
                            }
                        })
                        .catch(error => {
                            this.change_status("Problem initiating")
                            console.log('oops problem triggering all events for this job chain')
                        })
                })
                .catch(error => {
                    this.change_status("Unknown jobchain — probably a URL problem")
                    console.log('oops problem getting job chain information')
                })
            if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
            this.get_queue_positions()
            this.get_crawl_definition()
            done_sound = new window.Howl({
                src: ['/audio/music_flute_welcome.wav'],
                onend: () => {
                    this.auto_advance_redirect()
                }
            });
            warning_sound = new window.Howl({
                src: ['/audio/music_piano_warning.wav'],
            });
            error_sound = new window.Howl({
                src: ['/audio/music_timpani_error_05.wav']
            });
        },
        computed: {
            latest_values: function() {
              if (this.raw_to_date && this.raw_to_date.hasOwnProperty('retries')) {
                let obj = {}
                obj.redirects = -1 * this.raw_to_date.redirects[this.raw_to_date.redirects.length - 1]
                obj.retries = -1 * this.raw_to_date.retries[this.raw_to_date.retries.length - 1]
                obj.failures = this.raw_to_date.failures[this.raw_to_date.failures.length - 1]
                obj.successes = this.raw_to_date.successes[this.raw_to_date.successes.length - 1]
                obj.sitemap = this.raw_to_date.sitemap[this.raw_to_date.sitemap.length - 1]
                obj.will_retry = this.raw_to_date.will_retry[this.raw_to_date.will_retry.length - 1]
                obj.remaining = this.raw_to_date.remaining[this.raw_to_date.remaining.length - 1]

                return obj
              }
            },
            gallery_endpoint: function() {
              return '/api/jobChains/screenshots/' + this.job_chain_id + '?v=' + this.screenshot_version
            },
            chart_height: function() {
                if (!this.is_full_screen) return 250
                else {
                    return screen.height - 30
                }
            },
            chart_width: function() {
                if (!this.is_full_screen) return 1108
                else {
                    return screen.width - 30
                }
            },
            toggle_text: function() {
                if (this.distribution==='linear') return "Evenly distribute points"
                return "Distribute points based on time"
            },
            lock_series_text: function() {
                if (this.lock_series) return "Unlock chart"
                else return "LOCK chart"
            },
            error_report_link: function() {
              return "/errors/" + this.crawl_step_id
            },
            waiting_text: function() {
                let waiting = this.my_queue_position
                if (waiting == null) {
                    return "Oops! We have one of the dreaded 'internal errors'. Contact info@davidhobbsconsulting.com for help."
                }
                else if (waiting < 0) {
                    return "Looking up your position in the queue."
                } else if (waiting === 0) {
                    return "Your job should start within a few seconds."
                } else {
                    let people_in_front = (waiting > 1 ? "are " : "is ") + waiting + (waiting > 1 ? " people" : " person")
                    return "There " + people_in_front + " in front of you. Refresh this screen to refresh your place in line."
                }
            },
            llm_usage_display: function() {
                if (!this.has_received_llm_cost || this.current_llm_cost === 0) {
                    return null;
                }

                if (this.current_llm_cost >= 1 && this.current_llm_cost < 10000) {
                    return "LLM Cost: < 0.01";
                } else if (this.current_llm_cost > 10000) {
                    const costInCents = this.current_llm_cost / 1000000;
                    return `LLM Cost: ${costInCents.toFixed(2)}`;
                }

                return null;
            }
        },
        data() {
            return {
                final_status: null,

                crawl_step_id: null,
                crawl_definition: null,
                timeSeriesData: '',
                raw_to_date: null,
                max_timestamp: null,
                first_timestamp: null,
                duration_in_seconds: 0,
                is_full_screen: false,

                steps: {},
                status_text: "Unknown",
                column_width: 24,
                chain_done: false,
                chain_display_name: "",
                extent_id: null,
                extent_name: "",
                chain_type: "",
                active_url_list: [],
                aborted_crawl: false,
                heartbeat_images_length: 8,
                heartbeat_index: 0,
                distribution: 'linear',
                lock_series: false,

                is_terminal_status: false,
                show_bleeding_edge: false,
                restarted: false,

                updates_since_last_graph_reset: 0,

                queue_positions: [],
                my_queue_position: -1,
                show_waiting_message: false,
                showConfirmCancel: false,

                updating_crawl_queue: true,

                last_screenshot_timestamp: null,
                screenshot_version: 1,

                current_llm_cost: 0,
                has_received_llm_cost: false
            }
        },
        methods: {
            auto_advance_redirect() {
                if (this.auto_advance) {
                    // advance here
                    window.location.href = '/reports/e/' + this.extent_id
                }
            },
            chime($event) {
                if ($event === 'done') {
                    done_sound.play();
                } else if ($event === 'warning') {
                    warning_sound.play();
                } else if ($event === 'error') {
                    error_sound.play()
                }
            },
            visibilityChange(e) {
              console.log('vis change: document.hidden = ',document.hidden);
              if (document.hidden)  {
                if (this.duration_in_seconds >= 1) {
                  console.log('hidden')
                  this.updating_crawl_queue = false
                } else {
                  console.log('although document.hidden is true, we just started the progress so we will assume it as visible')
                  this.updating_crawl_queue = true
                }
              } else {
                console.log('visible')
                this.getInitialTimeSeriesData()
                this.updating_crawl_queue = true
              }
            },
            listen() {
                Echo.channel('job_chain_status.' + this.job_chain_id)
                    .listen('JobProgressUpdate', (event) => {
                        this.heartbeat()
                        // console.log(event)
                        // console.log(event)
                        // console.log(event.percentage)
                        // console.log(event.job_type)
                        // console.log(event.job_step_id)
                        if (event.time > this.steps[event.job_step_id].highest_time_received) {
                            this.steps[event.job_step_id].highest_time_received = event.time
                            this.steps[event.job_step_id].percentage = event.percentage
                            this.steps[event.job_step_id].current_count_done = event.current_count_done
                            this.steps[event.job_step_id].current_count_total = event.current_count_total
                            this.steps[event.job_step_id].elapsed = event.elapsed

                            // Update LLM cost if present in the event
                            if (event.llm_cost !== undefined) {
                                this.current_llm_cost = event.llm_cost
                                this.has_received_llm_cost = true
                            }

                          window.FavIconX.setValue(event.percentage)
                            // console.log(this.active_url_list)

                            if (event.chain_status === "canceled") {
                                // console.log("successfully canceled")
                                this.chime('warning')
                                this.chain_done = true
                                this.change_status("Successfully canceled")
                                if (event.job_type === "App\\DataImportJob") {
                                    this.aborted_crawl = true
                                }
                                this.is_terminal_status = true
                            } else if (event.chain_status === "done") {
                                this.chain_done = true
                                this.change_status("Completed")
                                this.is_terminal_status = true
                                if (this.duration_in_seconds <= 3) {
                                    console.log("auto advancing if appropriate")
                                    console.log(this.duration_in_seconds)
                                    this.auto_advance_redirect()
                                } else {
                                    console.log("playing chime (and then will auto-advance if appropriate")
                                    this.chime('done')
                                }

                            } else if (event.chain_status === "met_limit") {
                                this.chime('warning')
                                // console.log("met limit")
                                let status_message = "UNKNOWN"
                                if (this.auto_advance) {
                                    status_message = "Met your limit. Automatically moving on with partial import. Contact info@davidhobbsconsulting.com for more URLs."
                                } else {
                                    status_message = "Organizational limits met. Contact info@davidhobbsconsulting.com for more URLs."
                                }
                                this.change_status(status_message)
                                if (event.job_type === "App\\DataImportJob") {
                                    this.chain_done = true
                                    this.aborted_crawl = true
                                    this.is_terminal_status = true
                                }

                            } else if (event.chain_status === "failed") {
                                // console.log("Job Failed")
                                this.chime('error')
                                this.chain_done = true
                                this.is_terminal_status = true
                                this.change_status("Failed")
                                axios.get("/progress/status/" + event.job_step_id)
                                    .then(response => {
                                        this.change_status("Failed: " + response.data.error_message)
                                    })
                                    .catch(error => {
                                        this.change_status("Failed, and cannot get more details on the failure")
                                        console.log("Can not get details about failure")
                                    })
                            } else if (!this.is_terminal_status && event.current_count_done>0) {
                                this.change_status("Running")
                                if (this.updating_crawl_queue) {
                                  this.active_url_list = event.active_url_list
                                  let crawl_status = null
                                  if (crawl_status = event.my_crawl_status) {
                                    // console.log(crawl_status)
                                    this.updateTimeSeriesData(crawl_status)
                                  }
                                }
                            }
                        }
                    })
            },
            get_queue_positions() {
              // /api/queue_counts
                axios.get('/api/queue_counts')
                    .then(response => {
                        this.queue_positions = response.data
                        console.log(this.queue_positions)
                        this.my_queue_position = this.queue_positions[this.job_chain_id]
                        console.log(this.my_queue_position)
                    })
                    .catch(error => {
                        console.log("Could not get queue count")
                    })
                this.show_waiting_message = true // show the waiting message regardless of if we get a position
            },
            get_crawl_definition() {
              // /api/queue_counts
              axios.get('/api/jobChains/crawl_definition/' + this.job_chain_id)
                  .then(response => {
                    this.crawl_definition = response.data.pretty
                  })
                  .catch(error => {
                    console.log("Could not get crawl definition")
                  })
            },
            heartbeat() {
                this.heartbeat_index++
                if (this.heartbeat_index === this.heartbeat_images_length) {
                    this.heartbeat_index = 0
                }
                // console.log("about to get heartbeat image at index " + this.heartbeat_index)
                if (!this.first_timestamp) {
                    this.last_screenshot_timestamp = this.first_timestamp = new Date()
                    this.duration_in_seconds = 0
                    console.log('initializing first_timestamp')
                } else {
                    let current_timestamp = new Date()
                    this.duration_in_seconds = (current_timestamp.getTime() - this.first_timestamp.getTime()) / 1000;
                    if (
                        this.updating_crawl_queue &&
                        (current_timestamp.getTime() - this.last_screenshot_timestamp.getTime()) > 15 * 1000
                    ) {
                      this.last_screenshot_timestamp = current_timestamp
                      this.screenshot_version++
                    }
                }
            },
            hideConfirmCancel() {
              this.showConfirmCancel = false
            },
            confirmCancel() {
                this.showConfirmCancel = true
            },
            cancel() {
                this.showConfirmCancel = false
                axios.post('/api/jobChains/cancel/' + this.job_chain_id)
                    .then(response => {
                        this.change_status("Requested termination")
                    })
                    .catch(error => {
                        console.log('oops flattening')
                    })

            },
            restart() {
                axios.post('/api/jobChains/restart/' + this.job_chain_id)
                    .then(response => {
                        this.change_status("Restart requested")
                        this.chain_done = false
                        this.aborted_crawl = false
                        this.is_terminal_status = false
                        this.restarted = true
                    })
                    .catch(error => {
                        console.log('oops attempting to restart')
                    })
            },
            toggle_distribution() {
              if (this.distribution==='linear') this.distribution = 'series'
              else this.distribution = 'linear'
            },
            toggle_lock_series() {
              this.lock_series = !this.lock_series
            },
            change_status(status) {
              if (this.final_text) {
                this.status_text = this.final_text
              } else {
                // console.log("About to change status to " + status)
                if (this.status_text === "Requested termination") {
                  // console.log("We are already in a state of Requested termination")
                  if (status === "Successfully canceled") {
                    // console.log("About to change text status to successfully canceled")
                    this.status_text = status
                  } else if (status === "Restart requested") {
                    this.status_text = status
                  }
                } else {
                  this.status_text = status
                }
                if (this.status_text == "Completed") {
                  window.FavIconX.complete("green")
                  this.$emit('status_change', 'completed')
                } else if (this.status_text == "Failed") {
                  window.FavIconX.fail("red")
                } else if (this.status_text == "Successfully canceled") {
                  window.FavIconX.fail("orange")
                }
              }
            },
            unprotected_process() {
                axios.post('/api/jobChains', {
                    extent_id: this.extent_id,
                    type: "process",
                    operation: 'unprotected_process_raw_assets'
                }).then(response => {
                    console.log('success in creating job chain')
                    console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    console.log(response.data)
                    console.log(response.data.job_chain_id)
                    let auto_advance_text = this.auto_advance ? "/auto_advance" : ""
                    console.log(auto_advance_text)
                    window.location.href = '/progress/' + response.data.job_chain_id + auto_advance_text
                }).catch(error => {
                    console.log('oops problem starting scrape job')
                    console.log(error.response)
                })
            },
            full_screen() {
                const chart = document.getElementById('primary-chart')
                screenfull.request(chart)
                this.is_full_screen = true
                if (screenfull.enabled) {
                    screenfull.on('change', () => {
                        if (!screenfull.isFullscreen) this.is_full_screen = false
                    });
                }
            },
            setTimeSeriesData() {
                // console.log("just started setTimeSeriesData()")
                const colors = {
                  // above the line colors
                    lightyellow: {
                      fill: 'rgba(254,221,88,0.7)',
                      stroke: 'rgba(254,221,88,1)',
                    },
                    lightgray: {
                      fill: 'rgba(200,200,200,0.7)',
                      stroke: 'rgba(200,200,200,1)',
                    },
                    gray: {
                      fill: 'rgba(82,82,82,0.7)',
                      stroke: 'rgba(82,82,82,0.7)',
                    },
                    green: { // for crawled
                        fill: 'rgba(94,184,77,0.7)',
                        stroke: 'rgba(94,184,77,1)',
                    },
                    red: {
                        fill: 'rgba(127,0,0,0.7)',
                        stroke: 'rgba(127,0,0,1)',
                    },
                    // below the line colors
                    lightbrown: {
                        fill: 'rgba(177,81,24,0.7)',
                        stroke: 'rgba(177,81,24,1)'
                    },
                    lightblue: {
                      fill: 'rgba(51,142,247,0.7)',
                      stroke: 'rgba(51,142,247,1)'
                    },
                }
                // console.log("oh my gerd")

                this.timeSeriesData = {
                    labels: this.raw_to_date.timestamps,
                    datasets: [
                        {
                          label: "Redirects",
                          fill: true,
                          backgroundColor: colors.lightbrown.fill,
                          pointBackgroundColor: colors.lightbrown.stroke,
                          borderColor: colors.lightbrown.stroke,
                          pointHighlightStroke: colors.lightbrown.stroke,
                          data: this.raw_to_date.redirects,
                        },
                        {
                          label: "Retries",
                          fill: true,
                          backgroundColor: colors.lightblue.fill,
                          pointBackgroundColor: colors.lightblue.stroke,
                          borderColor: colors.lightblue.stroke,
                          pointHighlightStroke: colors.lightblue.stroke,
                          borderCapStyle: 'butt',
                          data: this.raw_to_date.retries,
                        },
                        {
                          label: "Final Errors",
                          fill: true,
                          backgroundColor: colors.red.fill,
                          pointBackgroundColor: colors.red.stroke,
                          borderColor: colors.red.stroke,
                          pointHighlightStroke: colors.red.stroke,
                          borderCapStyle: 'butt',
                          data: this.raw_to_date.failures,
                        },
                        {
                          label: "Crawled",
                          fill: true,
                          backgroundColor: colors.green.fill,
                          pointBackgroundColor: colors.green.stroke,
                          borderColor: colors.green.stroke,
                          pointHighlightStroke: colors.green.stroke,
                          borderCapStyle: 'butt',
                          data: this.raw_to_date.successes,
                        },
                        {
                          label: "Will Retry",
                          fill: true,
                          backgroundColor: colors.lightyellow.fill,
                          pointBackgroundColor: colors.lightyellow.stroke,
                          borderColor: colors.lightyellow.stroke,
                          pointHighlightStroke: colors.lightyellow.stroke,
                          borderCapStyle: 'butt',
                          data: this.raw_to_date.will_retry,
                        },
                        {
                            label: "Found organically",
                            fill: true,
                            backgroundColor: colors.gray.fill,
                            pointBackgroundColor: colors.gray.stroke,
                            borderColor: colors.gray.stroke,
                            pointHighlightStroke: colors.gray.stroke,
                            data: this.raw_to_date.remaining,
                        },
                        {
                            label: "Found in sitemap",
                            fill: true,
                            backgroundColor: colors.lightgray.fill,
                            pointBackgroundColor: colors.lightgray.stroke,
                            borderColor: colors.lightgray.stroke,
                            pointHighlightStroke: colors.lightgray.stroke,
                            data: this.raw_to_date.sitemap,
                        },
                    ]
                }
                // console.log("done setting timeSeriesData")
                // console.log(this.timeSeriesData)
            },
            getInitialTimeSeriesData() {
                let endPoint = '/progress/timeseries/' + this.crawl_step_id
                axios.get(endPoint)
                    .then(response => {
                        // console.log('raw time series data that we received back:')
                        // console.log(response.data)
                        this.raw_to_date = response.data
                        this.setTimeSeriesData()
                    }).catch(error => {
                        console.log(error.response)
                })
                this.updates_since_last_graph_reset = 0
            },
            updateTimeSeriesData(my_crawl_status) {
                if (!this.lock_series) {
                  this.updates_since_last_graph_reset++
                  if (this.updates_since_last_graph_reset > 600) {
                    this.getInitialTimeSeriesData()
                  }
                  let new_timestamp = my_crawl_status.time_of_status
                  // Events may come to us out of order. We just skip / don't display old data points.
                  // console.log("about to compare timestamps")
                  // console.log(this.max_timestamp)
                  // console.log(new_timestamp)
                  if (!this.max_timestamp) this.max_timestamp = new_timestamp
                  // console.log(Date.parse(this.max_timestamp))
                  // console.log(Date.parse(new_timestamp))
                  if (Date.parse(new_timestamp) > Date.parse(this.max_timestamp)) {
                    console.log("about to add another data point")
                    this.max_timestamp = new_timestamp
                    this.raw_to_date.redirects.push(-1 * my_crawl_status.count_redirects)
                    this.raw_to_date.retries.push(-1 * my_crawl_status.count_retries)
                    this.raw_to_date.failures.push(my_crawl_status.count_failures)
                    this.raw_to_date.successes.push(my_crawl_status.count_successes)
                    this.raw_to_date.sitemap.push(my_crawl_status.count_sitemap)
                    this.raw_to_date.will_retry.push(my_crawl_status.count_will_retry)
                    // it may be better for the backend to do the calculation of the remaining
                    // total = failures + successes + sitemap + remaining_found
                    // remaining_found = total - (failures + successes + sitemap)
                    this.raw_to_date.remaining.push(my_crawl_status.count_total_known - (my_crawl_status.count_failures + my_crawl_status.count_successes + my_crawl_status.count_sitemap + my_crawl_status.count_redirects + my_crawl_status.count_retries))
                    // console.log("about to set timestamps in updateTimeSeriesData()")
                    // console.log(my_crawl_status)
                    // console.log(my_crawl_status.time_of_status)
                    this.raw_to_date.timestamps.push(new_timestamp)
                    // console.log(my_crawl_status.time_of_status)
                    this.setTimeSeriesData()
                  }
                }
            }
        }
    }
</script>
